import { SVGProps } from "react"
const FileProgressIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.671875" width="60" height="60" rx="30" fill="#E5F3FF" />
    <path
      d="M42.75 34.9219V40.5885C42.75 41.34 42.4515 42.0607 41.9201 42.592C41.3888 43.1234 40.6681 43.4219 39.9167 43.4219H20.0833C19.3319 43.4219 18.6112 43.1234 18.0799 42.592C17.5485 42.0607 17.25 41.34 17.25 40.5885V34.9219"
      stroke="#2768A3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.916 27.8398L29.9993 34.9232L37.0827 27.8398"
      stroke="#2768A3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 34.9219V17.9219"
      stroke="#2768A3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default FileProgressIcon
